import { render, staticRenderFns } from "./VisiteCarri.vue?vue&type=template&id=f0670a88"
import script from "./VisiteCarri.vue?vue&type=script&lang=js"
export * from "./VisiteCarri.vue?vue&type=script&lang=js"
import style0 from "./VisiteCarri.vue?vue&type=style&index=0&id=f0670a88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports